<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9997 11.6667H16.6663V14.1667H19.1663V15.8333H16.6663V18.3333H14.9997V15.8333H12.4997V14.1667H14.9997V11.6667ZM9.99967 2.5C13.683 2.5 16.6663 3.99167 16.6663 5.83333C16.6663 7.675 13.683 9.16667 9.99967 9.16667C6.31634 9.16667 3.33301 7.675 3.33301 5.83333C3.33301 3.99167 6.31634 2.5 9.99967 2.5ZM3.33301 7.5C3.33301 9.34167 6.31634 10.8333 9.99967 10.8333C13.683 10.8333 16.6663 9.34167 16.6663 7.5V10.0667L15.833 10C13.6747 10 11.833 11.3667 11.133 13.2833L9.99967 13.3333C6.31634 13.3333 3.33301 11.8417 3.33301 10V7.5ZM3.33301 11.6667C3.33301 13.5083 6.31634 15 9.99967 15H10.833C10.833 15.875 11.058 16.7 11.458 17.4167L9.99967 17.5C6.31634 17.5 3.33301 16.0083 3.33301 14.1667V11.6667Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconAddMoney",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
